import { render, staticRenderFns } from "./HrTrainInstitute.vue?vue&type=template&id=5f2c0968&scoped=true&"
import script from "./HrTrainInstitute.vue?vue&type=script&lang=js&"
export * from "./HrTrainInstitute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c0968",
  null
  
)

export default component.exports